import { ReadDepartmentRecordsChannel } from '@/services/api/generated/policeDepartmentsService';

import {
  ExternalLink,
  InfoCard,
  SectionHeader,
} from './ChannelDisplayComponents';
import { MailingDetails } from './MailingDetails';

interface ChannelDetailsProps {
  channel: ReadDepartmentRecordsChannel;
}

export const ChannelDetails = ({ channel }: ChannelDetailsProps) => {
  return (
    <div className="space-y-4">
      {/* Instructions - only show if no mailing instructions */}
      {channel.instructions && !channel.mailing_instructions && (
        <InfoCard>
          <SectionHeader>How to Request</SectionHeader>
          <p className="text-sm leading-relaxed text-gray-700">
            {channel.instructions}
          </p>
        </InfoCard>
      )}

      {/* Mailing Instructions - comprehensive */}
      {channel.mailing_instructions && (
        <MailingDetails mailingInstructions={channel.mailing_instructions} />
      )}

      {/* Required Document */}
      {channel.required_document_url && (
        <InfoCard>
          <SectionHeader>Required Form</SectionHeader>
          <ExternalLink href={channel.required_document_url.url}>
            {channel.required_document_url.title}
          </ExternalLink>
        </InfoCard>
      )}

      {/* Sources */}
      {channel.handle?.sources && channel.handle.sources.length > 0 && (
        <InfoCard>
          <SectionHeader>Sources</SectionHeader>
          <div className="space-y-2">
            {channel.handle.sources.map((source, idx) => (
              <div key={idx}>
                <ExternalLink href={source.url}>{source.title}</ExternalLink>
              </div>
            ))}
          </div>
        </InfoCard>
      )}
    </div>
  );
};
